import { Link } from "react-router-dom";
import { ArrowRight, Radio, Tv, Newspaper, Globe2, Mic2, Video, Palette, PenLine } from "lucide-react";
import { useT } from "@/context/I18nContext";

const SERVICES = [
  { icon: Radio, label: "Radio" },
  { icon: Tv, label: "TV" },
  { icon: Newspaper, label: "Stampa" },
  { icon: Globe2, label: "Web" },
  { icon: Mic2, label: "Spot & Jingle" },
  { icon: Video, label: "Videoclip" },
  { icon: Palette, label: "Grafica" },
  { icon: PenLine, label: "Testi & sceneggiature" },
];

function fmt(str, italics) {
  // Replaces {italic}, {italic1}, {italic2} placeholders with styled spans
  const parts = str.split(/(\{italic\d?\})/g);
  return parts.map((p, i) => {
    const m = p.match(/^\{italic(\d?)\}$/);
    if (m) {
      const key = m[1] ? `italic${m[1]}` : "italic";
      return (
        <span key={i} className="italic text-[#E5A93C]">
          {italics[key]}
        </span>
      );
    }
    return p;
  });
}

export default function ServicesTeaser() {
  const { t } = useT();
  return (
    <section
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 border-t av-hairline"
      data-testid="services-teaser"
    >
      <div className="grid lg:grid-cols-[1.1fr_1fr] gap-10 items-start">
        <div>
          <span className="av-eyebrow">{t("services.eyebrow")}</span>
          <h2 className="font-serif-display text-3xl sm:text-5xl mt-3 leading-tight">
            {fmt(t("services.title"), { italic: t("services.italic") })}
          </h2>
          <p className="text-[#F7F4EE]/80 mt-5 leading-relaxed max-w-xl">
            {t("services.subtitle")}
          </p>
          <Link to="/servizi" className="av-pill av-pill-gold mt-8" data-testid="services-teaser-cta">
            {t("services.cta")} <ArrowRight size={14} />
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-3">
          {SERVICES.map((s) => (
            <div key={s.label} className="av-card p-5 flex items-start gap-3">
              <s.icon size={20} className="text-[#E5A93C] mt-0.5" />
              <div>
                <div className="text-sm font-medium">{s.label}</div>
                <div className="text-[11px] text-[#A39E93]">Promozione & produzione</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
